import { v4 as uuidv4 } from 'uuid';
import { DESIGNER_SETTINGS } from '../../constants/designer_settings';
import { getComponentDefaultDataByType } from '../helpers/components.helpers';
import { AnyComponentData } from '../package.models';

export class DesignerBase {
  _data = null;
  element: HTMLElement = null;
  componentType = null;
  cell = DESIGNER_SETTINGS.CELL;

  fixData(data): AnyComponentData {
    if (data === null) {
      return null;
    }

    let dataToReturn = data;

    const keys = Object.keys(data);

    if (keys.length === 1) {
      [this.componentType] = keys;

      const dataToMarge = getComponentDefaultDataByType(this.componentType);

      dataToReturn =
        dataToMarge !== undefined ? { ...dataToMarge, ...data[this.componentType] } : data[this.componentType];
    }

    return dataToReturn;
  }

  moveToFirst() {
    const parent = this.element.parentElement;
    const first = parent.querySelectorAll('.designer-component, .designer-note')[0];

    if (first !== this.element) {
      first.prepend(this.element);
    }
  }

  moveToLast() {
    const parent = this.element.parentElement;
    parent.append(this.element);
  }

  snapToGrid(value) {
    return Math.round(value / this.cell) * this.cell;
  }

  // eslint-disable-next-line class-methods-use-this
  toComponentName(str: string): string {
    if (typeof str === 'string') {
      return str
        .replace(/[(\-)]/g, '')
        .toLowerCase()
        .replace(/ /g, '_');
    }

    return str;
  }

  // eslint-disable-next-line class-methods-use-this
  uid() {
    return uuidv4();
  }
}
